/**
 * FilterToggleHandler
 * Handles mobile fold-out functionality for the filter section on sortIndex page
 */
export default class FilterToggleHandler {
  private toggleButton: HTMLElement | null = null;
  private filterRow: HTMLElement | null = null;

  constructor() {
    this.init();
  }

  private init(): void {
    // Find the toggle button and filter row
    this.toggleButton = document.querySelector(".filter-toggle");
    this.filterRow = document.querySelector(".row-filter");

    if (this.toggleButton && this.filterRow) {
      this.toggleButton.addEventListener("click", () => this.toggle());
    }
  }

  private toggle(): void {
    if (!this.toggleButton || !this.filterRow) return;

    const isExpanded =
      this.toggleButton.getAttribute("aria-expanded") === "true";

    // Toggle aria-expanded attribute
    this.toggleButton.setAttribute("aria-expanded", String(!isExpanded));

    // Toggle expanded class on filter row
    if (isExpanded) {
      this.filterRow.classList.remove("expanded");
    } else {
      this.filterRow.classList.add("expanded");
    }
  }
}
